import React from "react";

let Blurb = () => (
  <h3 className="section-subheading text-muted">
    Lone Goose Saloon is a Bar and Live Music Venue located in Huntsville Al
    inside of{" "}
    <a href="https://campus805.com/" target="blank">
      Campus 805
    </a>
    .
  </h3>
);

export default Blurb;



// WEBPACK FOOTER //
// ./src/scenes/landingPage/components/Blurb.js